import { FileFormElement as FileFormElementComponent } from '@faceup/abstract-form'
import type { ComponentProps } from 'react'

export const FileFormElement = (props: ComponentProps<typeof FileFormElementComponent>) => {
  return <FileFormElementComponent {...props} />
}
